import type { ReactNode } from 'react';
import { Box, Group } from '@optiaxiom/react';

import { useResizableSidebarWidth } from '@frontend/hooks';

import { rightSidebarResizeHandleStyles } from './RightSidebar.css';

type RightSidebarProps = {
  ariaLabel: string;
  children: ReactNode;
};

export function RightSidebar({ ariaLabel, children }: RightSidebarProps) {
  const { width, onPointerDown } = useResizableSidebarWidth();

  return (
    <Box
      asChild
      bg="bg.default"
      borderColor="border.default"
      borderL="1"
      display="flex"
      flexDirection="column"
      h="full"
      overflow="hidden"
      style={{
        position: 'relative',
        minWidth: 0,
        flex: `0 0 ${width}px`,
        width: `${width}px`,
      }}
    >
      <aside aria-label={ariaLabel}>
        <Box aria-hidden className={rightSidebarResizeHandleStyles} onPointerDown={onPointerDown} />
        <Group flex="1" flexDirection="column" style={{ minHeight: 0 }}>
          {children}
        </Group>
      </aside>
    </Box>
  );
}
